import { Dispatch } from "redux"
import { connect } from "react-redux"

// Models
import { RootState } from "../../../models"
import { RecordsStateType } from "../models"

// Selectors
import {
    selectCurrentRecord,
    selectCurrentRecordSignals,
    selectFetching,
    selectReceiveNextError,
    selectSignalFetching,
    selectRecordPDF,
    selectRecordPDFfetching,
} from "../store/selectors"

// Actions
import * as a from "../store/actions"

/**
 * @param state
 */
const mapStateToProps = (state: RootState) => ({
    currentRecord: selectCurrentRecord(state),
    currentRecordParameters: selectCurrentRecordSignals(state),
    fetchingRecord: selectFetching(state),
    fetchRecordError: selectReceiveNextError(state),
    fetchingRecordParameters: selectSignalFetching(state),
    pdf: selectRecordPDF(state),
    fetchingPDF: selectRecordPDFfetching(state),
});

/**
 * @param dispatch
 */
const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchNextRecord: () => dispatch(a.fetchNextRecordAsync.request()),
    fetchNextRecordById: (id: string) => dispatch(a.fetchNextRecordByIdAsync.request(id)),
    fetchInProgressNextRecordById:(id: string) => dispatch(a.fetchInProgressNextRecordByIdAsync.request(id)),
    fetchRecordById: (id: string) => dispatch(a.fetchRecordByIdAsync.request(id)),
    fetchRecordSignal: (id: string) => dispatch(a.fetchRecordSignalAsync.request(id)),
    fetchPDFRecord: (id: string) => dispatch(a.fetchPDFRecordAsync.request(id)),
    clearCurrentRecord: () => dispatch(a.clearCurrentRecord()),
});

export type WithRecordsProps = {
    pdf: RecordsStateType["pdf"]
    recordApproved: RecordsStateType["recordApproved"]
    fetchingPDF: RecordsStateType["fetchingPDF"]
    currentRecord: RecordsStateType["current"]
    currentRecordParameters: RecordsStateType["currentSignals"]
    fetchingRecord: RecordsStateType["fetching"]
    fetchingRecordParameters: RecordsStateType["fetchingSignals"]
    fetchRecordError: RecordsStateType["receiveNextError"]
    fetchNextRecord(): void
    fetchRecordSignal(): void
    clearCurrentRecord(): void
    fetchPDFRecord(id: string): void
    fetchRecordById(id: string): void
    fetchNextRecordById(id: string): void
    fetchInProgressNextRecordById(id: string): void
}

/**
 * @param BaseComponent
 */
export default (BaseComponent: any) => connect(mapStateToProps, mapDispatchToProps)(BaseComponent)
